/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, {Component} from 'react';
import PropTypes from "prop-types";
import Svg from "../../../../widgets/Svg/Svg";
import {getCSGQueryString, getFieldsToReturn} from '../../../../../_helpers/search/keywordSearch';
import AxiosClient from "../../../../../_helpers/http.helper";
import config from "../../../../../config";
import urlHelper from "../../../../../_helpers/url.format.server.helper";
import axios from 'axios';
import { AuthConsumer } from "../../../../context/AuthContext";
import ModalDialog from "../../../../widgets/ModalDialog/ModalDialog";

class AddContentInnerComponent extends Component {
    static get propTypes() {
        return {
            closeModal: PropTypes.func.isRequired,
            activeCollection: PropTypes.object,
            searchResults: PropTypes.object,
            resetSearchData: PropTypes.func,
            userId: PropTypes.string.isRequired
        };

    }
    constructor(props){
        super(props);
        this.state = {
            pageNumber: 1,
            pageSize: 10,
            isbn: '',
            author: '',
            title: '',
            collectionId: '',
            selectedResourceIds: [],
            insertAfter: props.selectedChapterResources.resourceData.length ? props.selectedChapterResources.resourceData.length : 0,
            searchResults: [],
            errorMsg: "",
            showForcedInclusionModal: false,
            additionalRequiredResources:[]
        };
        this.renderRows = this.renderRows.bind(this);
        this.openPDF = this.openPDF.bind(this);
        this.handleViewPDFClick = this.handleViewPDFClick.bind(this);
        this.searchByEnter = this.searchByEnter.bind(this);
        this.showHideForcedInclusionModal = this.showHideForcedInclusionModal.bind(this);
        this.addDependentResources = this.addDependentResources.bind(this);
        this.addToCollection = this.addToCollection.bind(this);
    }

    componentWillUnmount(){
        //  this.props.resetSearchData();
    }



    addRemoveResourceIds = (evt) => {

        const value = evt.currentTarget.value;
        const newSelectedResources = [...this.state.selectedResourceIds];
        const resIndex = newSelectedResources.indexOf(value);
        const isInList = resIndex >-1;
        const checked = evt.currentTarget.checked;

        if(checked && !isInList){
            //Add Resource
            this.setState({selectedResourceIds: [...newSelectedResources,value]});
        }
        if(!checked && isInList){
            //Remove Resource
            newSelectedResources.splice(resIndex, 1);
            this.setState({selectedResourceIds: [...newSelectedResources]});
        }

    };

    loadMore = (evt) =>{
        this.setNextPageNumber();
        // Do the search
        this.search(evt,{resetResult: false});

    };

    setNextPageNumber= () => {
        this.setState({pageNumber: this.state.pageNumber+1});
    };

    resetPageNumber = () => {
        this.setState({pageNumber: 1});
    };

    search = (evt,params = {resetResult: true}) =>{

        if(params.resetResult){
            this.resetPageNumber();
        }

        setTimeout(()=>{
            const {pageNumber,pageSize,isbn,author,title} = this.state;
            const searchTerm = title;
            const searchFields = [];
            const startIndex = 0;
            const activeCollection = this.props.activeCollection;

            const payload = {
                queryString: getCSGQueryString('Textbook', searchFields, searchTerm, 'Textbook', activeCollection),
                fieldsToReturn: getFieldsToReturn(),
                responseSize: 12,
                startIndex: startIndex,
                sort: {},
            };

            const url = urlHelper.formatUrl(
                config.csgSearch.baseUrl,
                config.csgSearch.routes.search,
            );

            const applicationId = {
                headers: { 'application-id': 'collection' }
            };

            delete AxiosClient.defaults.headers.common['X-UserId'];

            AxiosClient.post(url,payload,applicationId)
                .then(response => {

                    const searchResults  = response.data.searchResults;
                    const result = [];
                    const resourceIds = [];

                    searchResults.forEach((item) => {
                        resourceIds.push(item.source['cnt:auxiliaryFields'].resourceId);
                    });

                    const rebuildUrl = urlHelper.formatUrl(
                        config.contentService.baseUrl,
                        config.contentService.routes.getResourcesByIds,
                        {
                            queryParams:{
                                priceType: activeCollection.collectionType,
                                currency: activeCollection.geo.code,
                                fetchLinks: true,
                                validateRights: false
                            }
                        }
                    );

                    AxiosClient.post(rebuildUrl,resourceIds)
                        .then(response => {

                            this.setState({searchResults: response.data, errorMsg: "", selectedResourceIds:[]});

                        });

                })
                .catch(error => {
                    console.log("Error ", error);
                });

        },300);

    };

    addToCollection = (resourceIds, insertAfter) =>{

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.addResourcesToCollection,
            {
                collectionId: this.props.activeCollection.collectionId,
                chapterId: this.props.selectedChapterResources.chapterId
            }
        );

        const payload = {
            resourceIds: resourceIds,
            insertAfter: insertAfter
        };

        AxiosClient.defaults.headers.common['X-UserId'] = this.props.userId;

        AxiosClient.post(url,payload)
            .then(response => {

                this.props.loadCollection(this.props.activeCollection.collectionId);
            })
            .then(response => {

                this.props.closeModal();
            })
            .catch(error => {
                if(error.response.status === 403 && error.response.data.forcedInclusions){
                    this.getDependentResources(error.response.data.forcedInclusions);

                }
                if(error.response.status === 403 && !error.response.data.forcedInclusions){
                    this.setState({errorMsg: error.response.data.message});
                }
                console.log("Error ", error);
            });

    };

    isResourceAlreadyAdded = (resourceId) =>{

        if(this.props.activeCollection.resourceIds){
            return (this.props.activeCollection.resourceIds.indexOf(resourceId) > -1);
        }
        return false;
    };
    insertAfterChange = (evt)=> {
        const resCount = this.props.selectedChapterResources.resourceData.length;
        const instAfterVal = (evt.currentTarget.value === '' || (evt.currentTarget.value <= resCount) && (evt.currentTarget.value>-1))? evt.currentTarget.value: resCount;
        this.setState({insertAfter: instAfterVal});
    };
    validateInsertAfter = (evt) => {
        if(this.state.insertAfter.trim() === ''){
            this.setState({insertAfter: 0});
        }
    };

    changeHandler = (evt) =>{
        const evtValue = evt.currentTarget.value;

        switch(evt.currentTarget.id){
            case 'searchTitle':
                this.setState({title: evtValue});
                break;
            case 'searchIsbn':
                this.setState({isbn: evtValue});
                break;
            case 'searchAuthor':
                this.setState({author: evtValue});
                break;
        }

    };
  
    handleViewPDFClick (event) {
        const resourceId = event.currentTarget.value;
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getResourcePDFURL,
            {
                resourceId: resourceId
            }
        );

        AxiosClient.get(url)
            .then(response => {

                const win = window.open(response.data.url, '_blank');
                win.focus();

            })
            .catch(error => {
                console.log("Error ", error);

            });
    }
  
    openPDF (pdfURL) {
        this.props.resetPDFURL();
        const win = window.open(pdfURL, '_blank');
        win.focus();
    }

    searchByEnter (evt) {

        if (evt.which === 13) {
            evt.preventDefault();
            this.search();
        }
    }
    
    renderRows(searchResults) {
        return searchResults.map((resource,index) =>{
            const isSelectedItem =searchResults.indexOf(resource.resourceId) > -1 ;
            const RESOURCE_ALREADY_NOT_ADDED = !this.isResourceAlreadyAdded(resource.resourceId);

            return (<div className={isSelectedItem? "row selected" : RESOURCE_ALREADY_NOT_ADDED? "row" : "row inactive"} key={index}>
                <div className={"coloumn"}>
                    <span className="pe-checkbox ">
                        {
                            RESOURCE_ALREADY_NOT_ADDED ? <input  className="resource-select-icon"
                                onChange={this.addRemoveResourceIds} type='checkbox'
                                checked={this.state.selectedResourceIds.includes(resource.resourceId)}
                                value={resource.resourceId}/> :
                                <input  className="resource-select-icon" type='checkbox'disabled/>

                        }

                        <span>
                            <svg aria-hidden="true" focusable="false" className="pe-icon--check-sm-18">
                                <use xlinkHref="#check-sm-18"></use>
                            </svg>
                        </span>
                    </span>
                </div>
                <div className="coloumn">{resource.parentISBN}</div>
                <div className="coloumn">{resource.title}</div>
                <div className="coloumn">{resource.authors}</div>
                <div className="coloumn">{resource.resourceInfo.pageCount}</div>
                <div className="coloumn">${resource.price}</div>
                <div className="coloumn">
                    <button
                        disabled={!RESOURCE_ALREADY_NOT_ADDED}
                        className="viewPdfBtn"
                        value={resource.resourceId}  onClick={this.handleViewPDFClick} >
                       View PDF
                    </button>
                </div>
            </div>);
        });
    }

    showHideForcedInclusionModal = (status) => {
        this.setState({
            showForcedInclusionModal:status
        });
    };

    getResourceDetailsByIds = (resourceIds) => {
        const activeCollection = this.props.activeCollection;
        const rebuildUrl = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getResourcesByIds,
            {
                queryParams:{
                    priceType: activeCollection.collectionType,
                    currency: activeCollection.geo.code,
                    fetchLinks: true,
                    validateRights: false
                }
            }
        );
        return  AxiosClient.post(rebuildUrl,resourceIds);
    };

    getDependentResources = (resourcesIds) => {

        resourcesIds.forEach(resourcesId => {
            const dependentResource = [resourcesId.resourceId];
            let dependentResourceData;
            let requiredResourcesData;
            this.getResourceDetailsByIds(dependentResource).then(result =>{
                dependentResourceData = result.data;
                this.getResourceDetailsByIds(resourcesId.dependantResources).then(result =>{
                    requiredResourcesData = result.data;
                    const details = {
                        dependentResourceData: dependentResourceData[0],
                        requiredResourcesData: requiredResourcesData
                    };

                    const existingDetails = this.state.additionalRequiredResources;
                    existingDetails.push(details);
                    this.setState({
                        additionalRequiredResources:existingDetails
                    });
                });
            });

        });

        this.showHideForcedInclusionModal(true);
    };

    addDependentResources = () => {

        const dependentResourceIds = [];
        this.state.additionalRequiredResources.forEach(additionalRequiredResource =>{
            const requiredResources = additionalRequiredResource.requiredResourcesData;
            requiredResources.forEach(resource => {
                dependentResourceIds.push(resource.resourceId);
            });
        });

        let existingResourceIds = this.state.selectedResourceIds;
        existingResourceIds = existingResourceIds.concat(dependentResourceIds);
        this.setState({
            selectedResourceIds: existingResourceIds
        }, () => {
            this.addToCollection(this.state.selectedResourceIds,this.state.insertAfter-1);
        });
    };

    cancelForcedInclusionModal =  () => {
        this.setState({
            additionalRequiredResources: []
        });
        this.showHideForcedInclusionModal(false);
    };

    render(){
        const {selectedResourceIds,title,isbn,author} = this.state;
        const activateSearch =title.length > 0 || isbn.length || author.length;
        return(<div className="add-content-component">
            <div className='black-overlay'>
                <div className="add-content">
                    <div className="add-content-header">
                        <h3 className="title-header">Add Content</h3>
                        <div className="close-cross" onClick={this.props.closeModal}><Svg svgString={'remove-sm-18'}></Svg></div>
                    </div>
                    <div className="add-content-body">
                        <div className="search-area">
                            <div className='row'>
                                <div className="coloumn">
                                    <input type="text" className="pe-textInput--basic" placeholder="Search by title, ISBN or author" id="searchTitle" value={title} onChange={this.changeHandler} onKeyPress={this.searchByEnter}/>
                                </div>
                                <div className="coloumn">
                                    {activateSearch ? <button type="button" className="pe-btn pe-btn__primary search-btn" onClick={this.search}>Search</button> : <button type="button" className="pe-btn pe-btn__primary search-btn" disabled>Search</button>}
                                </div>
                            </div>
                        </div>
                        <div className='result-table-wrapper'>
                            <div className="result-table">
                                <div className='row'>
                                    <div className="coloumn table-header">Select</div>
                                    <div className="coloumn table-header">ISBN/Course Catalog</div>
                                    <div className="coloumn table-header">Title</div>
                                    <div className="coloumn table-header">Author</div>
                                    <div className="coloumn table-header">Pages</div>
                                    <div className="coloumn table-header">Price</div>
                                    <div className="coloumn table-header">PDF</div>
                                </div>

                                {this.state.searchResults && this.state.searchResults.length>0 && this.renderRows(this.state.searchResults)}
                            </div>
                        </div>
                    </div>
                    <div className="add-content-footer">
                        <div className="insert-after-wrapper">
                            <label>Insert After : </label>
                            <input
                                className="pe-textInput--basic insert-after-text-box"
                                type="text"
                                value={this.state.insertAfter}
                                onChange={this.insertAfterChange}
                                onBlur={this.validateInsertAfter}
                            />
                        </div>
                        <label className="error-msg">{this.state.errorMsg}</label>
                        <div className="button-wrappers">
                            <button type="button" className="pe-btn--btn_small close-btn" onClick={this.props.closeModal}>Close</button>
                            {selectedResourceIds.length > 0 ? <button className="pe-btn pe-btn__primary" onClick={()=>{this.addToCollection(this.state.selectedResourceIds,this.state.insertAfter-1);}}>Add</button> : <button className="pe-btn pe-btn__primary" disabled>Add</button>}

                        </div>
                    </div>
                </div>
            </div>

            <ModalDialog
                showModal={this.state.showForcedInclusionModal}
                onSuccess={this.addDependentResources}
                onCancel={this.cancelForcedInclusionModal}
                successText = "Add"
                title="Additional Resources Required"
            >

                {this.state.additionalRequiredResources.length > 0 && <div>
                    {
                        this.state.additionalRequiredResources.map((additionalResource, key) => {
                            return(
                                <div key={key}>
                                    <div>
                                        <div className="add-additional-resource">
                                            <h6 className="display-inline title">{additionalResource.dependentResourceData.title}</h6>
                                            <h6 className="display-inline title add-additional-resource-price">${additionalResource.dependentResourceData.price}</h6>
                                            <p>{additionalResource.dependentResourceData.programComponentTitle}</p>

                                            <p className="text">To add the resource you selected requires other materials by agreement with the resource's author.
                                                It will be automatically added to your Collection.</p>

                                            <p className="text">Additional Resource will be added:</p>

                                            {
                                                additionalResource.requiredResourcesData.map((requiredResourcesData,key )=> {
                                                    return (
                                                        <div key={key}>
                                                            <h6 className="display-inline title">{requiredResourcesData.title}</h6>
                                                            <h6 className="display-inline title add-additional-resource-price">${requiredResourcesData.price}</h6>
                                                            <p>{requiredResourcesData.programComponentTitle}</p>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>}
            </ModalDialog>
        </div>);
    }
}

const AddContentComponent = (props) => <AuthConsumer>
    {({ userProfile }) => <AddContentInnerComponent {...props} userId={userProfile ? userProfile.id : ""} />}
</AuthConsumer>;

export default AddContentComponent;


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/AddContentComponent.js